<div class="section-cards" [formGroup]="formRegister">
  <section class="section-card">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Metodologia</h3>
        </div>
        <p class="section-card__description">
          Selecione a metodologia de certificação aplicável ao projeto de carbono.
        </p>
      </div>
      <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>

    <div class="fields-row fields-row--1">
      <div class="field-group field-group--labeled">
        <b3-input-select
          formControlName="methodology"
          inputId="methodology"
          label="Metodologia"
          placeholder="Selecione a metodologia"
          background="white"
          maxHeight="280px"
          [options]="selectMethodology"
          [error]="checkHasError('methodology')"
          [hint]="[
            { show: checkHasError('methodology', 'required'), text: 'Campo obrigatório' },
            { show: checkHasError('methodology'), text: 'Preenchimento inválido' }
          ] | fieldHint">
          <b3-input-select-option
            *ngFor="let item of selectMethodology; let i = index"
            [attr.value]="item.inputId"
            [attr.index]="i"
            [id]="'methodology-option-' + item.inputId">
            {{ item.label }}
          </b3-input-select-option>
        </b3-input-select>
      </div>
    </div>
  </section>

  <section class="section-card">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Relatório de Adequação à Metodologia (RA)</h3>
        </div>
        <p class="section-card__description">
          Anexe o relatório que demonstra a aderência do projeto à metodologia selecionada.
        </p>
      </div>
      <span class="section-required-tag" aria-label="Obrigatório">Obrigatório</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>

    <div class="fields-row fields-row--1">
      <div class="field-group field-group--labeled">
        <b3-input-text
          formControlName="ramComplianceReportLink"
          inputId="ramComplianceReportLink"
          label="Link do Relatório de Adequação à Metodologia (RA)"
          background="white"
          mask="text"
          placeholder="Limite 100 caracteres"
          [maxlength]="100"
          [error]="checkHasError('ramComplianceReportLink') || isRamLinkInvalid()"
          [hint]="[
            { show: isRamLinkMissing() || checkHasError('ramComplianceReportLink', 'required'), text: 'Campo obrigatório' },
            { show: isRamLinkInvalid() || checkHasError('ramComplianceReportLink', 'pattern'), text: 'Link inválido' }
          ] | fieldHint">
        </b3-input-text>
      </div>
    </div>

    <div class="fields-row fields-row--1">
      <div class="field-group field-group--labeled field-group--textarea">
        <b3-input-area
          formControlName="ramComplianceReportDetail"
          inputId="ramComplianceReportDetail"
          label="Descrição do RA"
          background="white"
          placeholder="Limite 200 caracteres"
          [maxlength]="200"
          [error]="checkHasError('ramComplianceReportDetail') || characterCountRA >= 200"
          [hint]="[
            { show: checkHasError('ramComplianceReportDetail', 'required'), text: 'Campo obrigatório' },
            { show: characterCountRA >= 200, text: 'Limite atingido' }
          ] | fieldHint">
        </b3-input-area>
        <p class="character-count" [class.character-count--limit]="characterCountRA >= 200">
          {{ characterCountRA }}/200
        </p>
      </div>
    </div>
  </section>

  <section class="section-card">
    <div class="section-card__header">
      <div class="section-card__header-top">
      <div class="section-card__heading">
        <div class="section-header">
          <span class="section-header__accent" aria-hidden="true"></span>
          <h3 class="section-header__title">Documentos</h3>
        </div>
        <p class="section-card__description">
          Inclua documentação complementar, se houver, para apoiar a validação, análise e registro do projeto.
        </p>
      </div>
      <span class="section-optional-tag" aria-label="Opcional">Opcional</span>
      </div>
      <span class="section-card__divider" aria-hidden="true"></span>
    </div>

    <app-psa-add-others-links-documents [formRegister]="formRegister"></app-psa-add-others-links-documents>

    <div class="fields-row fields-row--1">
      <div class="field-group field-group--labeled field-group--textarea">
        <b3-input-area
          formControlName="documentDescription"
          inputId="documentDescription"
          label="Descrição das demais documentações"
          background="white"
          placeholder="Limite 500 caracteres"
          [maxlength]="500"
          [error]="checkHasError('documentDescription') || characterCountDocument >= 500"
          [hint]="[
            { show: characterCountDocument >= 500, text: 'Limite atingido' }
          ] | fieldHint">
        </b3-input-area>
        <p class="character-count" [class.character-count--limit]="characterCountDocument >= 500">
          {{ characterCountDocument }}/500
        </p>
      </div>
    </div>
  </section>
</div>
